import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './miscellaneous/not-found/not-found.component';
import { PagesComponent } from './pages.component';

const routes: Routes = [
  {
    path: '',
    component: PagesComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'article/:slug',
        loadChildren: () => import('./article/article.module').then(m => m.ArticleModule)
      },
      {
        path: 'california-supply-chain',
        loadChildren: () => import('./california-supply-chain/california-supply-chain.module').then(m => m.CaliforniaSupplyChainModule)
      },
      {
        path: 'careers',
        loadChildren: () => import('./careers/careers.module').then(m => m.CareersModule)
      },
      {
        path: 'contact',
        loadChildren: () => import('./contact/contact.module').then(m => m.ContactModule)
      },
      {
        path: 'cookie-list',
        loadChildren: () => import('./cookie-list/cookie-list.module').then(m => m.CookieListModule)
      },
      {
        path: 'confirmation',
        loadChildren: () => import('./miscellaneous/confirmation/confirmation.module').then(m => m.ConfirmationModule)
      },
      {
        path: 'distributors',
        loadChildren: () => import('./distributors/distributors.module').then(m => m.DistributorsModule)
      },
      {
        path: 'for-business',
        loadChildren: () => import('./for-business/for-business.module').then(m => m.ForBusinessModule)
      },
      {
        path: 'news',
        loadChildren: () => import('./news/news.module').then(m => m.NewsModule)
      },
      {
        path: 'not-found',
        loadChildren: () => import('./miscellaneous/not-found/not-found.module').then(m => m.NotFoundModule)
      },
      {
        path: 'our-people',
        loadChildren: () => import('./our-people/our-people.module').then(m => m.OurPeopleModule)
      },
      {
        path: 'our-story',
        loadChildren: () => import('./our-story/our-story.module').then(m => m.OurStoryModule)
      },
      {
        path: 'privacy-policy',
        loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
      },
      {
        path: 'recall-policy',
        loadChildren: () => import('./recall-policy/recall-policy.module').then(m => m.RecallPolicyModule)
      },
      {
        path: 'royal-prestige',
        loadChildren: () => import('./royal-prestige/royal-prestige.module').then(m => m.RoyalPrestigeModule)
      },
      {
        path: 'terms-of-use',
        loadChildren: () => import('./terms-of-use/terms-of-use.module').then(m => m.TermsOfUseModule)
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule {}
